var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveRoles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15C13.4167 15 13.7708 14.8542 14.0625 14.5625C14.3542 14.2708 14.5 13.9167 14.5 13.5C14.5 13.0833 14.3542 12.7292 14.0625 12.4375C13.7708 12.1458 13.4167 12 13 12C12.5833 12 12.2292 12.1458 11.9375 12.4375C11.6458 12.7292 11.5 13.0833 11.5 13.5C11.5 13.9167 11.6458 14.2708 11.9375 14.5625C12.2292 14.8542 12.5833 15 13 15ZM13 18C13.5167 18 13.9917 17.8792 14.425 17.6375C14.8583 17.3958 15.2083 17.075 15.475 16.675C15.1083 16.4583 14.7167 16.2917 14.3 16.175C13.8833 16.0583 13.45 16 13 16C12.55 16 12.1167 16.0583 11.7 16.175C11.2833 16.2917 10.8917 16.4583 10.525 16.675C10.7917 17.075 11.1417 17.3958 11.575 17.6375C12.0083 17.8792 12.4833 18 13 18ZM8 20C5.68333 19.4167 3.77083 18.0875 2.2625 16.0125C0.754167 13.9375 0 11.6333 0 9.1V3L8 0L16 3V8.675C15.6833 8.54167 15.3583 8.42083 15.025 8.3125C14.6917 8.20417 14.35 8.125 14 8.075V4.4L8 2.15L2 4.4V9.1C2 9.88333 2.10417 10.6667 2.3125 11.45C2.52083 12.2333 2.8125 12.9792 3.1875 13.6875C3.5625 14.3958 4.01667 15.05 4.55 15.65C5.08333 16.25 5.675 16.75 6.325 17.15C6.50833 17.6833 6.75 18.1917 7.05 18.675C7.35 19.1583 7.69167 19.5917 8.075 19.975C8.05833 19.975 8.04583 19.9792 8.0375 19.9875C8.02917 19.9958 8.01667 20 8 20ZM13 20C11.6167 20 10.4375 19.5125 9.4625 18.5375C8.4875 17.5625 8 16.3833 8 15C8 13.6167 8.4875 12.4375 9.4625 11.4625C10.4375 10.4875 11.6167 10 13 10C14.3833 10 15.5625 10.4875 16.5375 11.4625C17.5125 12.4375 18 13.6167 18 15C18 16.3833 17.5125 17.5625 16.5375 18.5375C15.5625 19.5125 14.3833 20 13 20Z",
    fill: "url(#paint0_linear_86_1654)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_1654",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD7409"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveRoles);
export default __webpack_public_path__ + "static/media/active_roles.ebcf3e7850ab6520bf139b16c43a37f5.svg";
export { ForwardRef as ReactComponent };